import $ from 'jquery';

export default function (name, type = 'default', format = 'DD/MM/YYYY', placeholder = null) {
  const options = {
    locale: {
      format: format,
    },
  };

  if (type === 'single') {
    options.singleDatePicker = true;
    options.showDropdowns = false;
  }

  const elements = $(`input[name=${name}]`);

  elements.daterangepicker(options);
  if (placeholder) {
    elements.val(placeholder);
  }
}

export function dataSetDaterangePicker () {
  const elements = $('input[data-datepicker]');

  elements.each((index, element) => {
    const dataset = element.dataset;

    const options = {
      locale: {
        format: 'DD/MM/YYYY',
      },
      singleDatePicker: true,
      minDate: dataset.minDate ? new Date() : '01/01/1900',
      maxDate: dataset.maxDate ? new Date() : '01/01/2100',
      showDropdowns: true,
    };

    $(elements[index]).daterangepicker(options);
    $(elements[index]).val(dataset.placeholder);
  });
}
